<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/color
include /@ibkr/lib.common/src/icon/misc
ib-dialog(
    :autoclose="true",
    v-model="show",
    :width="modalWidth",
)
    template(slot="header")
        h2.ib-col.insety-16 Regions
            span(class="float-right fs4" @click="close")
                +icon-basic-cancel_filled
    template(slot="default")
        div(class="flex-col", style="width:100%;")
            ib-tab-container(width="100%")
                template(v-slot:top)
                    ib-tab-bar
                        ib-tab2(key="a", class="insety-16") {{ $t('global') }}
                        ib-tab2(key="b") {{ $t('north_america') }}
                        ib-tab2(key="c") {{ $t('south_america') }}
                        ib-tab2(key="d") {{ $t('europe') }}
                        ib-tab2(key="e") {{ $t('asia') }}
                        ib-tab2(key="f") {{ $t('africa') }}
                        ib-tab2(key="g") {{ $t('oceania') }}
                ib-tab-pane(key="a", class="insety-16")
                    div(class="regions-tab odd-regions")
                        ib-button(
                            @click="selectAll('global')",
                            :class="{ active: selectGlobal }"
                            class="text-left text-bold after-8",
                        ) 
                            span {{ $t('select_all_regions') }}
                            span(
                                v-if="selectGlobal",
                                class="inset-8 text-left fg-positive"
                            )
                                +icon-color-yes
                ib-tab-pane(key="b", class="insety-16")
                    ib-row
                        ib-col(class="regions-tab")
                            ib-button(
                                class="text-left text-bold after-8",
                                @click="selectAll('na')",
                                :class="{ active: selectNA }",
                            )
                                span {{ $t('select_all') }}
                                span(
                                    v-if="selectNA",
                                    class="inset-8 fg-positive"
                                )
                                    +icon-color-yes
                            ib-button(
                                v-for="country in NACountries", 
                                :key="country.name",
                                :class="{ active: country.selected }",
                                class="text-left after-8",
                                @click="select(country.name)",
                            )
                                span {{ $t(country.name) }}
                                span(
                                    v-if="country.selected",
                                    class="fg-positive"
                                )
                                    +icon-color-yes
                ib-tab-pane(key="c", class="insety-16")
                    div(class="regions-tab odd-regions")
                        ib-button(
                            @click="selectAll('sa')",
                            :class="{ active: selectSA }",
                            class="text-left text-bold after-8"
                        ) 
                            span {{ $t('select_all') }}
                            span(
                                v-if="selectSA",
                                class="inset-8 fg-positive"
                            )
                                +icon-color-yes
                        ib-button(
                            v-for="country in SACountries",
                            :key="country.name",
                            :class="{ active: country.selected }",
                            class="text-left after-8",
                            @click="select(country.name)"
                        ) 
                            span {{ $t(country.name) }}
                            span(
                                v-if="country.selected",
                                class="fg-positive"
                            )
                                +icon-color-yes
                ib-tab-pane(key="d", class="insety-16")
                    div(class="regions-tab")
                        ib-button(
                            @click="selectAll('eu')",
                            :class="{ active: selectEU }",
                            class="text-left text-bold after-8"
                        )
                            span {{ $t('select_all') }}
                            span(
                                v-if="selectEU",
                                class="inset-8 fg-positive"
                            )
                                +icon-color-yes
                        ib-button(
                            v-for="country in EUCountries",
                            :key="country.id",
                            :class="{ active: country.selected }",
                            class="text-left  after-8"
                            @click="select(country.name)"
                        ) 
                            span {{ $t(country.name) }}
                            span(
                                v-if="country.selected",
                                class="fg-positive"
                            )
                                +icon-color-yes
                ib-tab-pane(key="e", class="insety-16")
                    div(class="regions-tab odd-regions")
                        ib-button(
                            @click="selectAll('ap')",
                            :class="{ active: selectAP }",
                            class="text-left text-bold after-8"
                        )
                            span {{ $t('select_all') }}
                            span(
                                v-if="selectAP",
                                class="inset-8 fg-positive"
                            )
                                +icon-color-yes
                        ib-button(
                            v-for="country in APCountries",
                            :key="country.id",
                            :class="{ active: country.selected}",
                            class="text-left  after-8"
                            @click="select(country.name)"
                        ) 
                            span {{ $t(country.name) }}
                            span(
                                v-if="country.selected",
                                class="fg-positive"
                            )
                                +icon-color-yes
                ib-tab-pane(key="f", class="insety-16")
                    div(class="regions-tab")
                        ib-button(
                            @click="selectAll('af')",
                            :class="{ active: selectAF }",
                            class="text-left text-bold after-8"
                        )
                            span {{ $t('select_all') }}
                            span(
                                v-if="selectAF",
                                class="inset-8 fg-positive"
                            )
                                +icon-color-yes
                        ib-button(
                            v-for="country in AFCountries",
                            :key="country.id",
                            :class="{ active: country.selected }",
                            class="text-left  after-8",
                            @click="select(country.name)"
                        ) 
                            span {{ $t(country.name) }}
                            span(
                                v-if="country.selected",
                                class="fg-positive"
                            )
                                +icon-color-yes
                ib-tab-pane(key="g", class="insety-16")
                    div(class="regions-tab")
                        ib-button(
                            @click="selectAll('oc')",
                            :class="{ active: selectOC }",
                            class="text-left text-bold after-8"
                        )
                            span {{ $t('select_all') }}
                            span(
                                v-if="selectOC",
                                class="inset-8 fg-positive"
                            )
                                +icon-color-yes
                        ib-button(
                            v-for="country in OCCountries",
                            :key="country.id",
                            :class="{ active: country.selected }",
                            class="text-left  after-8",
                            @click="select(country.name)"
                        ) 
                            span {{ $t(country.name) }}
                            span(
                                v-if="country.selected",
                                class="fg-positive"
                            )
                                +icon-color-yes
    template(slot="footer")
        ib-row(class="fullWidth",
            :class="{ '_fl_reverse' : $media.l }")
            ib-col(class="s12 l6")
                ib-button(
                @click="apply",
                class="added outsety-8 text-center",
                :class="{'float-right' : $media.l, 'fullWidth' : !$media.l }",
                :disabled="!allowApply",
                tone="accent",
                ) {{ $t('apply') }}
            ib-col(class="s12 l6")
                ib-button(
                @click="reset",
                class="cancelled outsety-8 text-center",
                :class="{'fullWidth' : !$media.l }"
                ) {{ $t('reset') }}
</template>
    
<script>
    
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'RegionSelection',
        data() {
            return {
                // Handle "select all for each region"
                selectGlobal: false,
                selectNA: false,
                selectSA: false,
                selectEU: false,
                selectAP: false,
                selectAF: false,
                selectOC: false,
                show: false,
                regions: [],
            }
        },
        
        methods: {
            apply() {
                this.$emit('apply', 'regions', this.regions);
                this.close();
            },
            reset() {
                const x = this.regions.forEach(item => item.selected = false);
                this.selectGlobal = false;
                this.selectNA = false;
                this.selectSA = false;
                this.selectEU = false;
                this.selectAP = false;
                this.selectAF = false;
                this.selectOC = false;
            },
            open(items) {
                // Deep copy
                this.regions = JSON.parse(JSON.stringify(items))
                // console.debug({items});
                // console.debug(this.regions);
                if (this.NACountries.length === this.NACountries.filter(item => item.selected).length) {
                    this.selectNA = true;
                }
                if (this.SACountries.length === this.SACountries.filter(item => item.selected).length) {
                    this.selectSA = true;
                }
                if (this.EUCountries.length === this.EUCountries.filter(item => item.selected).length) {
                    this.selectEU = true;
                }
                if (this.APCountries.length === this.APCountries.filter(item => item.selected).length) {
                    this.selectAP = true;
                }
                if (this.AFCountries.length === this.AFCountries.filter(item => item.selected).length) {
                    this.selectAF = true;
                }
                if (this.OCCountries.length === this.OCCountries.filter(item => item.selected).length) {
                    this.selectOC = true;
                }
                if (this.regions.length === this.regions.filter(item => item.selected).length) {
                    this.selectNA = true;
                    this.selectSA = true;
                    this.selectEU = true;
                    this.selectAP = true;
                    this.selectAF = true;
                    this.selectOC = true;
                    this.selectGlobal = true;
                }
                this.show = true;
            },
            close() {
                this.show = false;
            },
            selectAll(region) {
                let selected;
                if (region === 'global') {
                    selected = !this.selectGlobal;
                    const regions = this.regions;
                    regions.forEach(item => item.selected = selected);
                    console.debug({selected}, {regions});
                    Vue.set(this.regions, regions);
                    // this.setRegions(regions);
                    this.selectGlobal = selected;
                    this.selectNA = selected;
                    this.selectSA = selected;
                    this.selectEU = selected;
                    this.selectAP = selected;
                    this.selectAF = selected;
                    this.selectOC = selected;
                    return;
                }
                
                switch(region) {
                    case 'na':
                        selected = !this.selectNA;
                        this.selectNA = selected;
                        break;
                    case 'sa':
                        selected = !this.selectSA;
                        this.selectSA = selected;
                        break;
                    case 'eu':
                        selected = !this.selectEU;
                        this.selectEU = selected;
                        break;
                    case 'ap':
                        selected = !this.selectAP;
                        this.selectAP = selected;
                        break;
                    case 'af':
                        selected = !this.selectAF;
                        this.selectAF = selected;
                        break;
                    case 'oc':
                        selected = !this.selectOC;
                        this.selectOC = selected;
                        break;
                }

                const regions = this.regions;
                regions.forEach(item => {
                    if (item.region === region) {
                        item.selected = selected;
                    }
                })
                // this.setRegions(regions);
                Vue.set(this.regions, regions);
                this.selectGlobal = this.selectNA && this.selectSA && this.selectEU && this.selectAP && this.selectAF && this.selectOC;
            },
            select(name) {
                const index = this.regions.findIndex(item => item.name === name);
                const region = this.regions[index];
                region.selected = !region.selected;
                Vue.set(this.regions, index, region);
                // this.setRegion({index, region});

                // Make sure selectAll is set if they chose every region in a tab
                const isAllSelected = this.regions.filter(
                    item => item.region === region.region && item.selected).length === this.regions.filter(item => item.region === region.region).length;

                switch(region.region) {
                    case 'na':
                        this.selectNA = isAllSelected;
                        break;
                    case 'sa':
                        this.selectSA = isAllSelected;
                        break;
                    case 'eu':
                        this.selectEU = isAllSelected;
                        break;
                    case 'ap':
                        this.selectAP = isAllSelected;
                        break;
                    case 'af':
                        this.selectAF = isAllSelected;
                        break;
                    case 'oc':
                        this.selectOC = isAllSelected;
                        break;
                }

                this.selectGlobal = this.selectNA && this.selectSA && this.selectEU && this.selectAP && this.selectAF && this.selectOC;
            },
            ...mapActions(['setSelectedRegionTab'])
        },
        computed: {
            NACountries: function() {
                return this.regions.filter(item => item.region === 'na');
            },
            SACountries: function() {
                return this.regions.filter(item => item.region === 'sa');
            },
            EUCountries: function() {
                return this.regions.filter(item => item.region === 'eu');
            },
            APCountries: function() {
                return this.regions.filter(item => item.region === 'ap');
            },
            AFCountries: function() {
                return this.regions.filter(item => item.region === 'af');
            },
            OCCountries: function() {
                return this.regions.filter(item => item.region === 'oc');
            },
            selectedTab: {
                get: function() {
                    return parseInt(this.$store.state.selectedRegionTab);
                },
                set: function(newValue) {
                    this.setSelectedRegionTab(parseInt(newValue));
                }
            },
            modalWidth: function() {
                if ($media.xxl) {
                    return '50%';
                }
                else if ($media.l) {
                    return '80%';
                }
                else {
                    return '100%';
                }
            },
            allowApply: function() {
                return this.regions.filter(item => item.selected).length > 0;
            },
            ...mapState(['selectedRegionTab'])
        },
        mounted() {
            this.selectGlobal = this.selectNA && this.selectSA && this.selectEU && this.selectAP && this.selectAF && this.selectOC;
        },
    }
</script>
<style lang="less">
    @import "../less/globals.less";

    /* Display Reset/Submit, but flip order on smaller screens */
    ._fl_reverse {
        flex-direction: row-reverse !important;
    }

    .regions-tab {
        position: relative;
        display: flex;
        flex-flow: wrap;

        button {
            flex: 1 1;
            flex-basis: 100%;
        }

        .active {
            background-color:#ccebda !important;
        }
    }

    @media(min-width: 1220px) {
        .regions-tab {
            button {
                /* Margin / outline causing issues at 50% */
                flex-basis: 48%;
            }
        }

        /* Handle odd number of elements */
        .regions-tab.odd-regions {
            button:last-child {
                flex-grow: 0.025;
            }
        }
    }
</style>